/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import React from 'react';

// UI lib dependencies;
import Typography from '@mui/material/Typography';

// Style
import styles from './styles';
import { truncateString } from 'common/utils';
/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function CellSmallText({ text }) {
  /* ******************************** RENDERING ******************************* */
  return <Typography sx={styles.cellText}>{text}</Typography>;
}

export default CellSmallText;
